import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Calendar, ArrowRight } from 'lucide-react';
import '../styles/Pages.css';

const News = () => {
  const newsArticles = [
    {
      id: 1,
      title: 'VillaTracking expande operaciones a Colombia y Chile',
      date: '15 de Junio, 2023',
      excerpt: 'Como parte de su plan de expansión regional, VillaTracking anuncia el inicio de operaciones en Colombia y Chile, llevando sus soluciones de rastreo vehicular a nuevos mercados.',
      image: 'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      category: 'Expansión'
    },
    {
      id: 2,
      title: 'Nueva versión de la aplicación móvil con funcionalidades mejoradas',
      date: '28 de Mayo, 2023',
      excerpt: 'VillaTracking lanza la versión 3.0 de su aplicación móvil, con una interfaz rediseñada y nuevas funcionalidades que mejoran la experiencia del usuario y amplían las capacidades de monitoreo en tiempo real.',
      image: 'https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      category: 'Producto'
    },
    {
      id: 3,
      title: 'VillaTracking recibe premio a la innovación tecnológica',
      date: '10 de Abril, 2023',
      excerpt: 'En la feria internacional de tecnología LogiTech 2023, VillaTracking fue reconocida con el premio a la innovación tecnológica por su sistema avanzado de predicción de mantenimiento basado en IA.',
      image: 'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      category: 'Reconocimientos'
    },
    {
      id: 4,
      title: 'Alianza estratégica con importante empresa de logística',
      date: '22 de Marzo, 2023',
      excerpt: 'VillaTracking anuncia una alianza estratégica con LogiExpress, una de las principales empresas de logística de Latinoamérica, para implementar soluciones de rastreo en su flota de más de 500 vehículos.',
      image: 'https://images.pexels.com/photos/4481259/pexels-photo-4481259.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      category: 'Alianzas'
    },
    {
      id: 5,
      title: 'VillaTracking implementa tecnología de conducción ecológica',
      date: '15 de Febrero, 2023',
      excerpt: 'Como parte de su compromiso con la sostenibilidad, VillaTracking lanza una nueva funcionalidad que permite monitorear y optimizar el consumo de combustible y las emisiones de CO2 de las flotas.',
      image: 'https://images.pexels.com/photos/2284170/pexels-photo-2284170.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      category: 'Sostenibilidad'
    },
    {
      id: 6,
      title: 'Webinar: Optimización de rutas y reducción de costos operativos',
      date: '5 de Enero, 2023',
      excerpt: 'VillaTracking organiza un webinar gratuito para mostrar cómo las empresas pueden reducir hasta un 30% sus costos operativos mediante la optimización de rutas y el monitoreo eficiente de sus flotas.',
      image: 'https://images.pexels.com/photos/3182781/pexels-photo-3182781.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      category: 'Eventos'
    }
  ];

  return (
    <div className="page-container">
      <Header scrolled={true} />
      
      <main className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1>Noticias y Novedades</h1>
            <p>Mantente al día con las últimas novedades de VillaTracking</p>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="news-featured">
              <div className="featured-image">
                <img src={newsArticles[0].image} alt={newsArticles[0].title} />
                <span className="news-category">{newsArticles[0].category}</span>
              </div>
              <div className="featured-content">
                <div className="news-date">
                  <Calendar size={16} />
                  <span>{newsArticles[0].date}</span>
                </div>
                <h2>{newsArticles[0].title}</h2>
                <p>{newsArticles[0].excerpt}</p>
                <a href={`/news/${newsArticles[0].id}`} className="btn btn-primary">Leer Más</a>
              </div>
            </div>
            
            <div className="news-grid">
              {newsArticles.slice(1).map(article => (
                <div className="news-card" key={article.id}>
                  <div className="news-image">
                    <img src={article.image} alt={article.title} />
                    <span className="news-category">{article.category}</span>
                  </div>
                  <div className="news-content">
                    <div className="news-date">
                      <Calendar size={14} />
                      <span>{article.date}</span>
                    </div>
                    <h3>{article.title}</h3>
                    <p>{article.excerpt}</p>
                    <a href={`/news/${article.id}`} className="news-link">
                      Leer Más <ArrowRight size={14} />
                    </a>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="pagination">
              <button className="pagination-btn active">1</button>
              <button className="pagination-btn">2</button>
              <button className="pagination-btn">3</button>
              <button className="pagination-btn">
                <ArrowRight size={16} />
              </button>
            </div>
          </div>
        </section>
        
        <section className="page-section page-section-alt">
          <div className="container">
            <div className="newsletter-signup">
              <h2>Suscríbete a Nuestro Boletín</h2>
              <p>Recibe las últimas noticias y actualizaciones directamente en tu bandeja de entrada</p>
              <form className="newsletter-form-large">
                <input type="email" placeholder="Tu dirección de email" required />
                <button type="submit" className="btn btn-primary">Suscribirse</button>
              </form>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default News;